import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.localPrice)?_c('div',[(_vm.elementsOptions.clientSecret)?_c('stripe-element-payment',{ref:"paymentRef",attrs:{"pk":_vm.pk,"elements-options":_vm.elementsOptions,"confirm-params":_vm.confirmParams,"test-mode":_vm.testMode}}):_vm._e(),_c(VBtn,{attrs:{"color":"success"},on:{"click":_vm.pay}},[_vm._v("Pay Now")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }